<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-text-field-filled
                v-model="search"
                label="Recherche"
                @change="resetSelected()"
                density="compact"
                append-inner-icon="$fa-search"
                clearable
                @click:clear="search = ''"
            />
        </v-col>
        <v-col cols="12" class="pt-3">
            <v-list style="height: 27vh; overflow: scroll" lines="two">
                <v-list-item
                    v-for="item in productsList"
                    :key="item.id"
                    @click="selectProduct(item)"
                    :class="getProductClass(item.id)"
                    style="border-color: rgba(0, 0, 0, 0.12)"
                    data-cy="selectInvoiceProduct-product"
                    variant="outlined"
                    :title="item.title + ' - ' + item.reference"
                    :subtitle="item.unitPrice + '&#x20ac; (' + item.vatRate + ' %)'"
                >
                    <template v-slot:append class="my-0">
                        <v-btn-icon
                            color="primary"
                            :icon="
                                item.id === selectedProduct.id
                                    ? '$radio_button_checked'
                                    : '$radio_button_unchecked'
                            "
                        >
                        </v-btn-icon>
                    </template>
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import { InvoiceProduct } from "../../../../types";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["product"],
})
export class SelectInvoiceProduct extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) invoiceProductType: string;
    @Prop({ default: false }) dark: boolean; // ???

    selectedProduct = {
        id: "",
    };

    search = "";

    get productsList() {
        if (!this.search) {
            return this.products;
        }
        return this.products
            .filter(
                (product) =>
                    product.title.toLowerCase().includes(this.search.toLowerCase()) ||
                    product.reference.toLowerCase().includes(this.search.toLowerCase()),
            )
            .sort((a, b) => a.title.localeCompare(b.title));
    }

    @Apollo(
        {
            query: gql`
                query products($companyId: ID!, $type: InvoiceProductType) {
                    invoiceProducts(
                        where: { company: { id: $companyId }, type: $type, outDated_not: true }
                    ) {
                        id
                        reference
                        title
                        description
                        unitPrice
                        vatRate
                    }
                }
            `,
            variables() {
                return {
                    companyId: this.companyId,
                    type: this.invoiceProductType || undefined,
                };
            },
            skip() {
                return !this.companyId;
            },
        },
        (data) => (data ? data.invoiceProducts : []),
    )
    products: InvoiceProduct[] = [];

    selectProduct(product) {
        this.selectedProduct = product;
        this.$emit("product", product);
    }

    getProductClass(productId) {
        let productClass = "mt-2 rounded-lg";
        if (this.selectedProduct.id && productId === this.selectedProduct.id) {
            productClass += " selected ";
        } else {
            productClass += " bg-white ";
        }
        return productClass;
    }

    resetSelected() {
        this.selectedProduct = {
            id: "",
        };
    }
}

export default toNative(SelectInvoiceProduct);
</script>
<style>
.selected {
    background: #e5e5e5;
}
</style>
